export default class DataManagementJob {
    constructor (dto) {
        this.id = 0
        this.description = ''
        this.conditionStr = ''
        this.displayConditionStr = ''
        this.type = null

        if (dto) {
            this.id = dto.Id
            this.description = dto.Description
            this.conditionStr = dto.SearchPattern
            this.displayConditionStr = dto.SearchPattern
            this.type = dto.Type
        }
    }

    toDto () {
        return {
            Id: this.id,
            Description: this.description,
            SearchPattern: this.conditionStr,
            Type: this.type,
        }
    }
}
